module.exports = __webpack_public_path__ + "static/media/megabus-logo-background.fffc952a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/megabus-logo-background.svg
// module id = 300
// module chunks = 0